<template>
        <div class="single index not-found uk-first-section-xlarge-padding">
        <div class="uk-section uk-padding-4xlarge-bottom">
            <div class="uk-background-gradient-7 uk-height-viewport uk-position-top"></div>
            <div class="uk-container">
                <div class="text-wrap">
                    <h1>{{ $t("message.job_not_found")}}</h1>
                    <p>{{ $t("message.job_expired")}}</p>
                    <a :href="link">
                        <span>{{ $t("message.search_again")}}</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'NotFound',
    props: [],
    data() {
      return {}
    },
    computed: {
      link: function(){
        return window.location.origin + ( this.$i18n.locale === "ja" ? "/jp/careers/" : "/careers/" );
      }
    }
  };
</script>
